import { GdsAddressFragment, Maybe } from '../generated/graphql';

export const validAddress = (location?: Maybe<GdsAddressFragment>): boolean => {
  if (!location) {
    return false;
  }

  const { street1 = '', city = '', zip = '', state = '' } = location;
  return [street1, city, state, zip].every(Boolean);
};
export default validAddress;
